<form [formGroup]="periodSectionsForm">
  <mat-toolbar class="activities-toolbar">
    <mat-menu #addSection="matMenu">
      @for (type of periodSectionTypes$ | async; track type.id) {
        <button
          (click)="appendSection(type)"
          type="button"
          mat-menu-item
          >
          <span>{{ 'program.period.section_type.' + getNameForProgramPeriodSectionType(type.id) | translate }}</span>
        </button>
      }
    </mat-menu>
    @if (!readOnly) {
      <div class="flex-row items-start">
        <button mat-icon-button type="button" [matMenuTriggerFor]="addSection" [matTooltip]="'program.period_sections.activity.add.tooltip' | translate">
          <mat-icon>add</mat-icon>
        </button>
        <button
          mat-icon-button
          [matTooltip]="'program.period_sections.activity.select.tooltip' | translate"
          [class.selecting]="selectingSections"
          (click)="toggleSelection()"
          >
          <mat-icon>compare_arrows</mat-icon>
        </button>
        @if (selectingSections && (periods$ | async).length > 1) {
          <button mat-button [disabled]="selectedSectionsLength === 0" (click)="promptSectionMove()">
            {{ 'generic.move' | translate }}
          </button>
        }
        @if (selectingSections) {
          <button mat-button [disabled]="selectedSectionsLength === 0" (click)="promptSectionCopy()">
            {{ 'generic.copy' | translate }}
          </button>
        }
        @if (selectingSections) {
          <button mat-button [disabled]="selectedSectionsLength === 0" (click)="promptSectionRemove()">
            {{ 'generic.remove' | translate }}
          </button>
        }
        <button mat-icon-button (click)="setPanelBackToPDF()" [matTooltip]="'program.period_sections.back_to_pdf.tooltip' | translate">
          <mat-icon>visibility</mat-icon>
        </button>
      </div>
    }
  </mat-toolbar>
  @if (periodSectionsToShow$ | async; as periodSections) {
    <div class="period-sections-container">
      <app-panel-container
        cdkDropList
        [cdkDropListData]="periodSections"
        (cdkDropListDropped)="dropPeriodSection($event)"
        class="period-sections"
        appExpansionPanelController
        >
        <ng-template let-periodActivityIndex="index">
          @if (periodSections[periodActivityIndex]; as section) {
            @if (periodSectionsForm.get('' + section.id)) {
              <mat-expansion-panel
                cdkDrag
                [class.first-section]="periodActivityIndex === 0"
                [class.page-break]="section.type_id === EProgramPeriodSectionType.PAGE_END"
                class="period-section-panel"
                [class.selected]="isSelectedSection(section.id)"
                (click)="panelSelected(section.id)"
                [disabled]="selectingSections"
                [expanded]="isOpenedSection(section.id)"
                >
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <app-drag-handle cdkDragHandle></app-drag-handle>
                    <span class="panel-title">
                      @if (getActivityIsExcluded(section)) {
                        <mat-icon class="archived-icon" [matTooltip]="'program_details.activity.excluded.tooltip' | translate">do_not_disturb_on</mat-icon>
                      }
                      @if (!getActivityIsExcluded(section) && section.activity_archived) {
                        <mat-icon class="archived-icon" [matTooltip]="'program_details.activity.archived.tooltip' | translate">delete</mat-icon>
                      }
                      @if (programLanguage && section.language && programLanguage.toLowerCase() !== section.language.toLowerCase()) {
                        <mat-icon [svgIcon]="section.language.toLowerCase()"></mat-icon>
                      }
                      {{ 'program.period.section_type.' + getNameForProgramPeriodSectionType(section?.type_id) | translate }}
                      @if (section?.type_id === EProgramPeriodSectionType.PAGE_END) {
                        ............................................................
                      }
                    </span>
                  </mat-panel-title>
                  <mat-panel-description>
                    @if (section?.type_id === EProgramPeriodSectionType.ACTIVITY) {
                      {{ (section.title !== '' ? section.title : ('generic.new' | translate)) }}
                    }
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                  <!-- If this section is an image section, we'll need to be able to drag and drop images all throughout the section. -->
                  @if (mediaLikeSectionTypes.includes(section?.type_id)) {
                    <app-asset-upload
                      [identifier]="section.id.toString()"
                      [purpose]="getProgramPeriodSectionPurpose(section?.type_id)"
                    >
                      <!-- Declare a context variable uploadData, and pass it the "uploadData" from the app-asset-upload component -->
                      <ng-template let-uploadData="uploadData">
                        <!-- Then pass this uploadData to the section, which pass it to the image section. -->
                        <app-section
                          (archived)="removeSection(section)"
                          (saved)="saveSection(section.id)"
                          [section]="section"
                          [formControlName]="section.id"
                          [uploadData]="uploadData"
                          [readOnly]="readOnly"
                          [sectionContainerType]="ESectionContainerType.PROGRAM_PERIOD"
                        ></app-section>
                      </ng-template>
                    </app-asset-upload>
                  }
                  @else {
                    @if (section?.type_id !== EProgramPeriodSectionType.PAGE_END) {
                      <app-section
                        (saved)="saveSection(section.id)"
                        (archived)="removeSection(section)"
                        [section]="section"
                        [formControlName]="section.id"
                        [readOnly]="readOnly"
                        [sectionContainerType]="ESectionContainerType.PROGRAM_PERIOD"
                      ></app-section>
                    }
                  }
                  @if (section?.type_id === EProgramPeriodSectionType.PAGE_END || section?.type_id === EProgramPeriodSectionType.ACTIVITY) {
                    <div
                      class="button-container"
                      >
                      @if (section?.type_id === EProgramPeriodSectionType.PAGE_END && !readOnly) {
                        <button
                          (click)="removeSection(section)"
                          mat-button
                          type="button"
                          >
                          {{ 'program.period_sections.page_end.remove' | translate }}
                        </button>
                      }
                      @if (section?.type_id === EProgramPeriodSectionType.ACTIVITY && section?.activity_id) {
                        <button
                          (click)="openActivity(section)"
                          mat-button
                          type="button"
                          >
                          {{ 'program.period_sections.activity.view' | translate }}
                        </button>
                      }
                    </div>
                  }
                </ng-template>
              </mat-expansion-panel>
            }
          }
        </ng-template>
      </app-panel-container>
    </div>
  }
</form>
